import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { parseMoneyInput } from '../../shared/helper/utils';

@Directive({
  selector: '[appRendaValidator],[appRendaValidator][ngModel]',
  providers: [{
    multi: true,
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => RendaValidatorDirective)
  }]
})
export class RendaValidatorDirective {

  @Input() valorMinimo: number = 1000;
  @Input() valorMaximo: number;
  @Input() valorMinimoMessage = 'O valor mínimo deve ser R$';

  constructor() { }
  validate(c: AbstractControl): { [key: string]: any } {
    return (this.checkValidate(this.formatInput(c.value)) ? null : {
      message: this.getErrorMessage()
    });
  }

  checkValidate(valor) {
    if (this.existeValorMaximo()) {
      return valor >= Number(this.minValue) && valor <= Number(this.maxValue);
    }
    return valor >= Number(this.minValue);
  }

  formatValue(value) {
    if (value) {
      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return '0,00';
  }

  formatInput(value) {
    if (typeof value === 'number') {
      return value ?? 0;
    }
    return parseMoneyInput(value);
  }

  getErrorMessage(): string {
    if (this.existeValorMaximo()) {
      return `A renda deve estar entre R$ ${this.formatValue(this.minValue)} e R$ ${this.formatValue(this.maxValue)}`;
    }
    return `${this.valorMinimoMessage} ${this.formatValue(this.minValue)}`;
  }

  existeValorMaximo(): boolean {
    return this.valorMaximo >= 0;
  }

  get minValue(): number {
    return this.valorMinimo ?? 0;
  }

  get maxValue(): number {
    return this.valorMaximo ?? 0;
  }
}
